<template>
  <div class="create-other-meeting">
    <el-form ref="otherRef" :model="otherMeetingModel" :rules="rules">
      <el-form-item label="会议类型：" required>
        <el-checkbox :value="false" disabled>综合议题会议</el-checkbox>
        <el-checkbox :value="true">其他专题会议</el-checkbox>
      </el-form-item>
      <el-form-item label="开始时间：" prop="startTime">
        <el-date-picker
          v-model="otherMeetingModel.startTime"
          type="datetime"
          placeholder="-请选择-"
          default-time="9:00:00"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间：" prop="endTime" required>
        <el-date-picker
          v-model="otherMeetingModel.endTime"
          type="datetime"
          placeholder="-请选择-"
          default-time="12:00:00"
          :picker-options="endTimePickerOptions"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="会议地点：" prop="meetingRoom">
        <el-input
          v-model="otherMeetingModel.meetingRoom"
          placeholder="-请输入-"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="会议议题：" prop="meetingTitle">
        <el-input
          v-model="otherMeetingModel.meetingTitle"
          placeholder="-请输入-"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="会议类别：" prop="checkList">
        <el-checkbox-group v-model="otherMeetingModel.checkList">
          <el-checkbox
            v-for="(item, index) in typeList"
            :label="item.value"
            :key="index"
          ></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="会议内容：" prop="content">
        <el-input
          type="textarea"
          v-model="otherMeetingModel.content"
          :rows="5"
          placeholder="-请输入-"
          maxlength="300"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item
        label="出席人员："
        prop="participanceList"
        ref="attendPeopleRef"
        :class="[otherMeetingModel.participanceList.length > 0 ? 'select-box' : '']"
      >
        <div class="el-input tag-wrapper">
          <el-tag
            v-for="tag in otherMeetingModel.participanceList"
            @close="closeParticipance(tag)"
            :key="tag.id"
            closable
            style="margin-right: 5px;"
            >{{ tag.displayName || tag.name }}</el-tag
          >
        </div>
        <el-button @click="selectParticipanceList" type="primary"
          >选择</el-button
        >
      </el-form-item>
    </el-form>
    <div class="btn-wrapper">
      <el-button type="primary" @click="submitOtherMeeting">确定</el-button>
      <el-button @click="cancelOtherMeeting" type="info">取消</el-button>
      
      
    </div>
    <select-dialog
      :visible="selectDialogVisible"
      @close="selectDialogClose"
      title="选择出席人员"
      v-bind="selectDialogOptions"
    />
  </div>
</template>

<script>
import SelectDialog from "@/page/meeting/bill/SelectDialog";
import {
  getOtherConferenceTypeList,
  createOtherConference,
} from "@/services/conferenceServices";
import Constants from "@/utils/consts";
export default {
  name: "CreateOtherMeeting",
  components: {
    SelectDialog,
  },
  data() {
    const validateEndTime = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请选择结束时间"));
      } else if (
        this.otherMeetingModel.startTime &&
        value.getTime() <= this.otherMeetingModel.startTime.getTime()
      ) {
        callback(new Error("结束时间不得早于开始时间"));
      } else {
        callback();
      }
    };
    return {
      rules: {
        startTime: [
          {
            type: "date",
            required: true,
            message: "请选择开始时间",
            trigger: "change",
          },
        ],
        endTime: [
          {
            validator: validateEndTime,
            trigger: ["blur", "change"],
          },
        ],
        meetingRoom: [
          { required: true, message: "请输入会议室", trigger: "blur" },
        ],
        meetingTitle: [
          { required: true, message: "请输入会议议题", trigger: "blur" },
        ],
        checkList: [
          {
            type: "array",
            required: true,
            message: "请选择会议类别",
            trigger: "change",
          },
        ],
        content: [
          { required: true, message: "请输入会议内容", trigger: "blur" },
        ],
        participanceList: [
          {
            type: "array",
            required: true,
            message: "请选择出席人员",
            trigger: "change",
          },
        ],
      },
      otherMeetingModel: {
        startTime: undefined, //开始时间和结束时间
        endTime: undefined,
        meetingRoom: "", // 会议室
        meetingTitle: "", // 会议标题
        checkList: [], // 选定的会议类型
        content: "", //会议内容
        participanceList: [], //出席人员
      },
      typeList: [], // 会议类型
      selectDialogOptions: {
        //出席人员选择配置
        departOn: true,
        groupOn: true,
        canSelectDepart: false,
        canSelectUser: true,
        canSelectGroup: true,
        maxSelectedItem: 0,
        dataKey: "other-participance",
      },
      selectDialogVisible: false,
      endTimePickerOptions: {
        disabledDate: (time) => {
          let startTime = this.otherMeetingModel.startTime;
          if (!startTime) {
            // 如果没有选定开始时间，那什么时间都可以选
            return false;
          }
          // 这里在判断时间是否可选时，time是按照考查的这一天的00：00：00来算的
          let year = startTime.getFullYear();
          let month = startTime.getMonth() + 1;
          let date = startTime.getDate();
          let _startTime = new Date(`${year}-${month}-${date} 00:00:00`);
          if (_startTime.getTime() <= time.getTime()) {
            // 如果开始时间存在，并且开始时间比time时间早，那就可以选time
            return false;
          }
          return true;
        },
      },
    };
  },
  methods: {
    onActive() {
      this.initMeetingTypeList();
    },
    initMeetingTypeList() {
      getOtherConferenceTypeList()
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            this.typeList = res.data || [];
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {});
    },

    closeParticipance(user) {
      let index = this.otherMeetingModel.participanceList.findIndex(
        (item) => item.id == user.id && item.meetingType == user.meetingType
      );
      if (index != -1) {
        this.otherMeetingModel.participanceList.splice(index, 1);
      }
    },
    selectParticipanceList() {
      // 选择出席人员
      this.selectDialogVisible = true;
    },
    selectDialogClose(data) {
      // 关闭选择出席人员dialog
      this.selectDialogVisible = false;
      const { dataKey } = data;
      if (dataKey == this.selectDialogOptions.dataKey) {
        let userList = data.userList || [];
        let groupList = data.groupList || [];
        userList.forEach((user) => {
          // 区分下选择的是人还是群组。人和群组的数据VO不一样，没啥共同性，没法用个啥属性标记出来
          user.meetingType = "user";
        });
        groupList.forEach((group) => {
          group.meetingType = "group";
        });
        let list = userList.concat(groupList);
        // 这样子直接复制，逻辑简单，但会出现问题：如果想打开再添加几个人，结果却会是重新设置成那几个人，所以不能这样
        list.forEach((item) => {
          let index = this.otherMeetingModel.participanceList.findIndex(
            (ele) => item.meetingType == ele.meetingType && item.id == ele.id
          );
          if (index == -1) {
            this.otherMeetingModel.participanceList.push(item);
          }
        });

        this.$refs.attendPeopleRef.$emit(
          "el.form.change",
          this.otherMeetingModel.participanceList
        );
      }
    },

    getTypeParam() {
      // 组合出会议类型的参数
      let res = [];
      this.otherMeetingModel.checkList.forEach((item) => {
        // checkbox-group选择的结果就是些字符串
        let target = this.typeList.find((ele) => ele.value == item);
        if (target) {
          res.push(target.label);
        }
      });
      return res;
    },

    submitOtherMeeting() {
      this.$refs.otherRef.validate((valid) => {
        if (!valid) {
          return false;
        }
        let params = {
          //会议内容
          content: this.otherMeetingModel.content,
          // 出席人员
          joinWorkJson: JSON.stringify(this.otherMeetingModel.participanceList),
          // 会议室
          room: this.otherMeetingModel.meetingRoom,
          // 开始时间
          startTime: this.otherMeetingModel.startTime.toISOString(),
          endTime: this.otherMeetingModel.endTime.toISOString(),
          // 会议主题
          title: this.otherMeetingModel.meetingTitle,
          // 会议类型
          typeSet: this.getTypeParam(),
        };
        createOtherConference(params)
          .then((res) => {
            if (res.code == Constants.Code_OK) {
              this.$alert(Constants.Add_OK_Msg, "提示");
              // 创建完后，就关闭创建窗口
              this.closeOtherMeeting();
              // 再次调用打开，刷新列表
              this.bus.$emit("navMenuChange", {
                routeId: "other-meeting",
              });
            } else {
              this.$alert(res.msg, "提示");
            }
          })
          .catch((error) => {});
      });
    },
    cancelOtherMeeting() {
      this.$confirm("您确定要取消吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.closeOtherMeeting();
        })
        .catch(() => {});
    },
    closeOtherMeeting() {
      // 关闭窗口
      this.bus.$emit("tabClose", "createOtherMeeting");
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/commonLayout.scss";
.create-other-meeting {
  background-color: white;
  padding: 20px 20px 50px;
  width: 72%;
}

/deep/ .el-form-item__content {
  display: flex;

  /deep/.el-input {
    flex: 1;
  }

  .el-button {
    margin-left: 10px;
    height: fit-content;
  }
}

.tag-wrapper {
  border: 1px solid #dcdfe6;
  padding: 0 5px;
}

.btn-wrapper {
  margin-top: 20px;
  text-align: center;
}

.select-box {
  /deep/.el-form-item__content {
    align-items: center;
  }
}
</style>
